// routes
import {PATH_DASHBOARD} from "../../../routes/path";
// components
import SvgColor from "../../../components/svg-color";
import {OPERATORS_GROUP} from "../../../constants";

// ----------------------------------------------------------------------

export const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{width: 1, height: 1}}/>;


// ----------------------------------------------------------------------

const ICONS = {
    discount: icon("ic_discount"),
    blog: icon("ic_blog"),
    cart: icon("ic_cart"),
    chat: icon("ic_chat"),
    mail: icon("ic_mail"),
    user: icon("ic_user"),
    file: icon("ic_file"),
    lock: icon("ic_lock"),
    label: icon("ic_label"),
    blank: icon("ic_blank"),
    kanban: icon("ic_kanban"),
    folder: icon("ic_folder"),
    banking: icon("ic_banking"),
    booking: icon("ic_booking"),
    invoice: icon("ic_invoice"),
    calendar: icon("ic_calendar"),
    disabled: icon("ic_disabled"),
    external: icon("ic_external"),
    menuItem: icon("ic_menu_item"),
    ecommerce: icon("ic_ecommerce"),
    analytics: icon("ic_analytics"),
    dashboard: icon("ic_dashboard"),
    bus: icon("ic_bus"),
    report: icon("ic_report"),
    priceList: icon("ic_price_list"),
    stationList: icon("ic_station_list"),
    monthly: icon("ic_monthly"),
    locations: icon("ic_locations"),
    relations: icon("ic_relations"),
    departures: icon("ic_deparutres"),
    times: icon("ic_times"),
    reports: icon("ic_reports"),
    invoices: icon("ic_invoices"),
    carrier: icon("ic_carrier"),
    customers: icon("ic_customer"),
    insurance: icon("ic_insurance"),
};

export const navConfigUzice = [
    // ----------------------------------------------------------------------
    {
        subheader: "Početna",
        items: [
            {
                title: "Izveštaji",
                //roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.operator, OPERATORS_GROUP.accountant, OPERATORS_GROUP.manager],
                path: PATH_DASHBOARD.general.reports,
                icon: ICONS.reports
            }
        ]
    },
]
export const navConfig = [
        // ----------------------------------------------------------------------
        {
            subheader: "Početna",
            items: [
                {
                    title: "Početna",
                   // roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.operator, OPERATORS_GROUP.accountant, OPERATORS_GROUP.manager],
                    path: PATH_DASHBOARD.general.app,
                    icon: ICONS.bus
                },
                {
                    title: "Stanične usluge",
                    // roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.operator, OPERATORS_GROUP.accountant, OPERATORS_GROUP.manager],
                    path: PATH_DASHBOARD.general.stationServices,
                    icon: ICONS.bus
                },
                {
                    title: "Izveštaji",
                    //roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.operator, OPERATORS_GROUP.accountant, OPERATORS_GROUP.manager],
                    path: PATH_DASHBOARD.general.reports,
                    icon: ICONS.reports
                },
                {
                    title: "Lista Računa",
                    //roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.operator, OPERATORS_GROUP.accountant, OPERATORS_GROUP.manager],
                    path: PATH_DASHBOARD.general.invoices,
                    icon: ICONS.invoices
                },
                {
                    title: "Mesečne karte",
                    path: PATH_DASHBOARD.monthlyTicketsList.root,
                    icon: ICONS.monthly,
                    children: [
                        {title: "Lista mesečnih karti", path: PATH_DASHBOARD.monthlyTicketsList.list},
                        {title: "Dodavanje mesečne karte", path: PATH_DASHBOARD.monthlyTicketsList.new},
                    ]
                },
            ]
        },
        {
            subheader: "Panel",
            items: [
                {
                    title: "Popusti",
                    roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                    path: PATH_DASHBOARD.discounts.root,
                    icon: ICONS.discount,
                    children: [
                        {title: "Popusti", path: PATH_DASHBOARD.discounts.list},
                        {title: "Dodavanje popusta", path: PATH_DASHBOARD.discounts.new},
                    ]
                },
                {
                    title: "Vozni park",
                    roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                    path: PATH_DASHBOARD.bus.root,
                    icon: ICONS.bus,
                    children: [
                        {title: "Vozni park", path: PATH_DASHBOARD.bus.list},
                        {title: "Dodavanje vozila", path: PATH_DASHBOARD.bus.new},
                    ]
                },
                {
                    title: "Cenovnik",
                    roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                    path: PATH_DASHBOARD.priceList.root,
                    icon: ICONS.priceList,
                    children: [
                        {title: "Cenovnik", path: PATH_DASHBOARD.priceList.list},
                        {title: "Dodavanje cenovnika", path: PATH_DASHBOARD.priceList.new},
                        {title: "Stanice", path: PATH_DASHBOARD.priceList.stationsList},
                        {title: "Stanične usluge", path: PATH_DASHBOARD.priceList.stationsServicesList},
                        {title: "Dodavanje usluge", path: PATH_DASHBOARD.priceList.stationsServicesAdd},
                    ]
                },
                {
                    title: "Stanice",
                    roles: [OPERATORS_GROUP.superAdmin],
                    path: PATH_DASHBOARD.stationList.root,
                    icon: ICONS.stationList,
                    children: [
                        {title: "Lista stanica", path: PATH_DASHBOARD.stationList.list},
                        {title: "Dodavanje stanice", path: PATH_DASHBOARD.stationList.new},
                    ]
                },
                {
                    title: "Lokacije",
                    roles: [OPERATORS_GROUP.superAdmin],
                    path: PATH_DASHBOARD.locationList.root,
                    icon: ICONS.locations,
                    children: [
                        {title: "Lista lokacija", path: PATH_DASHBOARD.locationList.list},
                        {title: "Dodavanje lokacija", path: PATH_DASHBOARD.locationList.new},
                    ]
                },
                {
                    title: "Relacije",
                    roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                    path: PATH_DASHBOARD.linesList.root,
                    icon: ICONS.relations,
                    children: [
                        {title: "Lista relacija", path: PATH_DASHBOARD.linesList.list},
                        {title: "Dodavanje relacije", path: PATH_DASHBOARD.linesList.new},
                    ]
                },
                {
                    title: "Polasci",
                    roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                    path: PATH_DASHBOARD.departuresList.root,
                    icon: ICONS.departures,
                    children: [
                        {title: "Lista polazaka", path: PATH_DASHBOARD.departuresList.list},
                        {title: "Dodavanje polazaka", path: PATH_DASHBOARD.departuresList.new},
                    ]
                },
                {
                    title: "Vremena",
                    roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                    path: PATH_DASHBOARD.timesList.root,
                    icon: ICONS.times,
                    children: [
                        {title: "Lista vremena", path: PATH_DASHBOARD.timesList.list},
                        // {title: "Dodavanje vremena", path: PATH_DASHBOARD.timesList.new},
                    ]
                },
                {
                    title: "Baza kupaca",
                    roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                    path: PATH_DASHBOARD.customers.root,
                    icon: ICONS.customers,
                    children: [
                        {title: "Lista kupaca", path: PATH_DASHBOARD.customers.list},
                        {title: "Dodavanje kupaca", path: PATH_DASHBOARD.customers.new}
                    ]
                },
                // {
                //     title: "Prevoznici",
                //     roles: [OPERATORS_GROUP.admin, OPERATORS_GROUP.superAdmin],
                //     path: PATH_DASHBOARD.carriers.root,
                //     icon: ICONS.carrier,
                //     children: [
                //         {title: "Lista prevoznika", path: PATH_DASHBOARD.carriers.list},
                //         {title: "Dodavanje prevoznika", path: PATH_DASHBOARD.carriers.new}
                //     ]
                // },
                // {
                //     title: "Osiguranja",
                //     roles: [OPERATORS_GROUP.admin],
                //     path: PATH_DASHBOARD.insurance.root,
                //     icon: ICONS.insurance,
                //     children: [
                //         {title: "Lista osiguranja", path: PATH_DASHBOARD.insurance.list},
                //         {title: "Dodavanje osiguranja", path: PATH_DASHBOARD.insurance.new}
                //     ]
                // },
                // {
                //     title: "Usluge",
                //     roles: [OPERATORS_GROUP.admin],
                //     path: PATH_DASHBOARD.items.root,
                //     icon: ICONS.booking,
                //     children: [
                //         {title: "Lista usluga", path:  PATH_DASHBOARD.priceList.stationsServicesList},
                //         {title: "Dodavanje usluge", path: PATH_DASHBOARD.items.new}
                //     ]
                // }
            ]
        }
    ]
;

